import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import CrehanaLogo from "@crehana/icons/logos/CrehanaLogo";
import { Col } from "@crehana/ui";
import { css } from "styled-components";
const Copyright = ({ isDark, className })=>{
    const { t } = useTranslation('main-footer');
    return /*#__PURE__*/ jsxs(Col, {
        md: 8,
        lg: 6,
        nowrap: true,
        className: `${className} text-center md:text-left mt-24 sm:mt-48 lg:mt-0`,
        children: [
            /*#__PURE__*/ jsx("span", {
                className: `block sm:inline-block mb-20 sm:mb-0 ${isDark ? 'text-white' : 'text-primary-main'}`,
                children: /*#__PURE__*/ jsx(CrehanaLogo, {
                    size: 24,
                    ignoreColor: true,
                    className: "fill-current sm:mr-32"
                })
            }),
            /*#__PURE__*/ jsxs("span", {
                className: `font-legals ${isDark ? 'text-base-lighter' : 'text-gray-dark'}`,
                css: css`
          ${(props)=>props.theme.breakpoints.down('sm')} {
            white-space: pre-line;
          }
        `,
                children: [
                    `Copyright © Crehana ${new Date().getFullYear()} - \n`,
                    t('RIGHTS_RESERVED')
                ]
            })
        ]
    });
};
const BottomSection_Copyright = Copyright;
export default BottomSection_Copyright;
